import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Badge, Box, Button, Chip, FormControl, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Stack, TextField, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import React, { useCallback, useEffect, useMemo } from 'react';
import { getDynamicWidgetAPI, getWidgetDetails } from '../../../services/api-service';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import WidgetDownload from '../../Widget-Download/Widget-Download';
// import OZTable from '../../OZTable/OZTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Theme, useTheme } from '@mui/material/styles';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import { ReactComponent as DeleteIcon } from '../../../static/icons/deletenew.svg';
import { ReactComponent as RefreshOutlinedIcon } from '../../../static/icons/refresh.svg';
import { DynamicfilterTypes } from '../../../utils/constants';
import { checkRoles, secondsToTime } from '../../../utils/util';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import FilterDrawerCaseWise from '../../FilterDrawer/FilterDrawerCaseWise';
import OZCheckbox from '../../OZCheckbox/OZCheckbox';
import { showErrorNotification } from '../../admin/common/NotiService';
import { sanitizeInput } from '../../admin/common/OZInput';
import './NewDynamicWidget.css';


const formatSecondsToTime = (seconds: number): string => {
    if (isNaN(seconds) || seconds < 0) return '00:00:00';
    return secondsToTime(seconds);
};

// const thresholdFields = [
//     { label: 'Longest wait time', value: '', key: 'LongestWaitTime', condition: 'GREATER_THAN' },
//     { label: 'Calls Waiting', value: '', key: 'QueueCount', condition: 'GREATER_THAN' }
// ];

const checkForFilterId = (label: any) => {
    switch (label) {
        case "Campaign":
            return 1;
        case "Skill":
            return 2;
        case "Group":
            return 3;
        case "Location":
            return 4;
        case "Detail":
            return 5;
        case "Detail2":
            return 6;
        case "Detail3":
            return 7;
        case "Skill Detail Str":
            return 8;
        default:
            return 1;
    }
};

const NewDynamicWidget = (props: any) => {
    // console.log("here props comess", props);
    const { useState, useRef } = React;
    const theme = useTheme();
    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
    const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || checkForFilterId(props?.selectedFilters?.filterSelectionToShow ? props?.selectedFilters?.filterSelectionToShow[0] : 'Campaign'));
    const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
    const [responseLength, setresponseLength] = useState<Number>(0);
    const [rowData, setRowData] = useState<Array<any>>([]);
    const [columnData, setColumnData] = useState<Array<any>>([]);
    const [thresholdItems, setThresholdItems] = useState<Array<any>>([]);
    const [dynamicWidgetFilter, setDynamicWidgetFilter] = useState<Array<any>>(props?.selectedFilters?.filters || []);
    const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
    const downloadContent = useRef<any>(null);


    const [value1, setValue1] = useState(props?.selectedFilters?.procedureId || '');
    const [value2, setValue2] = useState(props?.selectedFilters?.dynamicHeaders || []);
    const [value3, setValue3] = useState(props?.selectedFilters?.headersToMap || '');
    const [selectedHeader, setSelectedHeader] = useState<string | null | any>('');
    const [newHeaderMap, setNewHeaderMap] = useState<Array<any>>(() => {
        const initialHeaders = props?.selectedFilters?.headersToMap ? JSON.parse(props?.selectedFilters?.headersToMap) : [];
        try {
            if (initialHeaders?.length > 0 && Array.isArray(initialHeaders)) {
                return initialHeaders.map((header: any) => ({
                    ...header,
                    isTime: header.isTime || false
                }));
            }
            return [];
        } catch (error) {
            console.log("error in formatting newHeaderMap", error)
            return initialHeaders;
        }
    });
    const [filterToShow, setFilterToShow] = useState<any>(props?.selectedFilters?.filterSelectionToShow || ['Campaign']);
    const [showFiltersAccordion, setShowFiltersAccordion] = useState<boolean>(false);

    const [isCaseFilter, setIsCaseFilter] = useState<boolean>(props?.widgetData?.isCaseFilter || false);
    const [caseFilters, setCaseFilters] = useState<any>(props?.widgetData?.caseFilters || { caseCondition: 'AND', caseFilters: [{ condition: 'AND', conditionFilters: [{ filterType: '', filterSection: null, selectedFilters: [] }] }] });
    const [isCaseFilterDrawerOpen, setIsCaseFilterDrawerOpen] = useState<boolean>(false);

    const procedureId = useRef<any>(props?.selectedFilters?.procedureId || '');
    const tempHeaders = useRef<any>(props?.selectedFilters?.dynamicHeaders || '');
    const tempHeadersToMap = useRef<any>(props?.selectedFilters?.headersToMap || '');
    const [showFilters, setShowFilters] = useState<any>(props?.enableWidgetEdit || false);
    const [toggleState, setToggleState] = useState<any>(false);
    const [lastFetchedTime, setLastFetchedTime] = useState<any>('');

    const [widgetTitleName, setWidgetTitleName] = useState<any>(props?.selectedFilters?.widgetTitleName || 'Dynamic Widget');
    const [apiParams, setApiParams] = useState<any>([]);
    const [selectedWidget, setSelectedWidget] = useState<any>(null);
    const [extraParameters, setExtraParameters] = useState<any>([]);
    const [inputValues, setInputValues] = useState<{ [key: string]: string }>(props?.selectedFilters?.extraParams || {});
    const [finalRefreshTime, setFinalRefreshTime] = useState<any>(props?.selectedFilters?.refreshInterval || 0);
    const isClickHouseQuery = useMemo(() => (selectedWidget?.widgetLocation === 6), [selectedWidget]);

    const tempFinalRefresh = useRef<any>(props?.selectedFilters?.refreshInterval || 0);
    const intervalRef = useRef<any>(null);
    // const [usersList, setUsersList] = useState<any>([]);
    // const selectedSubUserId = useRef<any>(props?.selectedFilters?.subUserId || '');
    // const [selectedSubUser, setSelectedSubUser] = useState<any>([]);

    // const prevSelectedSubUserIds = useMemo(() => {
    //     try {
    //         let userList = props?.selectedFilters?.subUserId || '';
    //         userList = userList ? userList.split(',').map((id: any) => parseInt(id, 10)) : [];
    //         if (props?.handleSaveDataToFilter && props?.widgetId) {
    //             props?.handleSaveDataToFilter({
    //                 widgetId: props?.widgetId,
    //                 value: {
    //                     disabledSubUserIds: userList
    //                 }
    //             })
    //         }
    //         return userList;
    //     } catch (error) {
    //         console.log("error in prevSelectedSubUserIds", error)
    //         return [];
    //     }
    // }, []);

    let dynamicWidget = true;

    const names = [
        'Campaign',
        'Skill',
        'Group',
        'Location',
        'Detail',
        'Detail2',
        'Detail3',
        'Skill Detail Str',
    ];

    const refreshTimeDropDown = [
        { value: 0, label: 'Manual Refresh' },
        { value: 5, label: '5 sec' },
        { value: 10, label: '10 sec' },
        { value: 15, label: '15 sec' },
        { value: 20, label: '20 sec' },
        { value: 25, label: '25 sec' },
        { value: 30, label: '30 sec' },
        { value: 35, label: '35 sec' },
        { value: 40, label: '40 sec' },
        { value: 45, label: '45 sec' },
        { value: 50, label: '50 sec' },
        { value: 55, label: '55 sec' },
        { value: 60, label: '1 min' },
        { value: 300, label: '5 min' },
        { value: 600, label: '10 min' },
        { value: 1200, label: '20 min' },
        { value: 1800, label: '30 min' },
    ];

    let tempColumns: any = [];

    useEffect(() => {
        if (!props?.enableWidgetEdit) {
            setWidgetTitleName(props?.selectedFilters?.widgetTitleName || 'Dynamic Widget');
            setInputValues(props?.selectedFilters?.extraParams || {});
            setFinalRefreshTime(props?.selectedFilters?.refreshInterval || 0);
            tempFinalRefresh.current = props?.selectedFilters?.refreshInterval || 0;
            // selectedSubUserId.current = props?.selectedFilters?.subUserId || '';
            setShowFilters(props?.enableWidgetEdit || false);
            tempHeadersToMap.current = props?.selectedFilters?.headersToMap || '';
            tempHeaders.current = props?.selectedFilters?.dynamicHeaders || '';
            procedureId.current = props?.selectedFilters?.procedureId || '';
            setFilterToShow(props?.selectedFilters?.filterSelectionToShow || ['Campaign']);
            const existingHeaders = props?.selectedFilters?.headersToMap ? JSON.parse(props?.selectedFilters?.headersToMap) : [];
            try {
                if (existingHeaders?.length > 0 && Array.isArray(existingHeaders)) {
                    const headersWithTimeProperty = existingHeaders.map((header: any) => ({
                        ...header,
                        isTime: header.isTime || false
                    }));
                    setNewHeaderMap(headersWithTimeProperty);
                } else {
                    setNewHeaderMap(existingHeaders);
                }
            } catch (error) {
                console.log("error in formatting newHeaderMap", error)
                setNewHeaderMap(existingHeaders);
            }
            setValue3(props?.selectedFilters?.headersToMap || '');
            setValue2(props?.selectedFilters?.dynamicHeaders || []);
            setValue1(props?.selectedFilters?.procedureId || '');
            setDynamicWidgetFilter(props?.selectedFilters?.filters || []);
            setFilterSection(props?.selectedFilters?.filterSection || {});
            setFilterType(props?.selectedFilters?.filterSection?.id || checkForFilterId(props?.selectedFilters?.filterSelectionToShow ? props?.selectedFilters?.filterSelectionToShow[0] : 'Campaign'));
        }

        if (props?.widgetData?.isCaseFilter) {
            setIsCaseFilter(props?.widgetData?.isCaseFilter);
            setCaseFilters(props?.widgetData?.caseFilters);
        }

    }, [props])

    const selectedCaseFiltersItems = useMemo(() => {
        let items: any = [];
        try {
            if (caseFilters?.caseFilters?.length > 0 && Array.isArray(caseFilters?.caseFilters)) {
                caseFilters.caseFilters.forEach((caseFilter: any) => {
                    if (caseFilter?.conditionFilters?.length > 0 && Array.isArray(caseFilter?.conditionFilters)) {
                        caseFilter?.conditionFilters?.forEach((condition: any) => {
                            if (condition?.selectedFilters && Array.isArray(condition?.selectedFilters)) {
                                let filterLabel = condition?.filterSection?.label;
                                condition?.selectedFilters?.forEach((filter: any) => {
                                    items.push(filterLabel + " - " + filter?.label);
                                });
                            }
                        });
                    }
                });
            }
            if (items?.length > 0) {
                items = [...new Set(items)];
            }
            return items;
        } catch (error) {
            console.log("error in selectedCaseFiltersItems", error)
            return [];
        }
    }, [caseFilters]);

    const caseFiltersLength = useMemo(() => {
        try {
            return selectedCaseFiltersItems?.length || 0;
        } catch (error) {
            console.log("error in caseFiltersLength", error)
            return 0;
        }
    }, [selectedCaseFiltersItems]);

    const caseFilterChipItems = useMemo(() => {
        return (selectedCaseFiltersItems?.length > 0 && Array.isArray(selectedCaseFiltersItems)) ? selectedCaseFiltersItems?.map((item: any, index: number) => (
            item ? <Chip key={index + item} label={item} color="primary" variant="outlined" /> : null
        )) : null;
    }, [selectedCaseFiltersItems]);

    const handleDownload = (type: string) => {
    };

    const toggleDrawer = (isOpen: boolean) => {
        setIsDrawerOpen(isOpen);
    };

    let box = useMemo(() => ({
        height: '100%', overflowY: 'auto', padding: '15px', marginLeft: '5px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0)'
    }), []);
    const deleteHeader = (index: number) => {
        setNewHeaderMap((prev) => prev.filter((header, i) => i !== index));
    };

    const updateHeader = (index: any, newHeaderName: any, newAlias: any, isTime?: boolean) => {
        setNewHeaderMap((prev) =>
            prev.map((header, i) =>
                i === index
                    ? {
                        ...header,
                        headerName: sanitizeInput(newHeaderName) || header?.headerName,
                        alias: sanitizeInput(newAlias) || header?.alias,
                        isTime: isTime || false
                    }
                    : header
            )
        );
    };

    const addHeader = (headerName = '') => {
        if (headerName) {
            // Handle "All" as in your existing logic
            if (headerName === 'All') {
                if (newHeaderMap?.length !== value2?.length - 1) {
                    let newHeaders = value2?.filter((item: any) => item !== 'All').map((header: any) => ({
                        headerName: header,
                        alias: '',
                        isTime: false,
                    }));
                    setNewHeaderMap(newHeaders);
                } else {
                    alert('All Headers already added.');
                }
            } else {
                // Handle unique headers
                const headerExists = newHeaderMap?.some((header) => header?.headerName.toLowerCase() === headerName?.toLowerCase());
                if (headerExists) {
                    alert('Header with this name already exists.');
                } else {
                    let newHeader = { headerName, alias: '', isTime: false };
                    setNewHeaderMap((prev) => [...prev, newHeader]);
                }
            }
            setSelectedHeader(null);
        } else {
            let newManualHeader = { headerName: '', alias: '', isTime: false };
            setNewHeaderMap((prev) => [...prev, newManualHeader]);
        }
    };

    useEffect(() => {
        makingColumn()
        if (newHeaderMap.length === 0) {
            setColumnData([])
        }
        props?.handleFilterChange?.(dynamicWidgetFilter, filterSection, props?.widgetId, value1, value2, JSON.stringify(newHeaderMap), filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    }, [newHeaderMap, filterToShow, inputValues, widgetTitleName])

    function transformCaseFiltersToApiParams(caseFiltersData: any) {
        try {
            if (!caseFiltersData || !caseFiltersData.caseFilters || !Array.isArray(caseFiltersData.caseFilters)) {
                return "0"; // Or return a default structure / throw error
            }

            const apiConditions = caseFiltersData.caseFilters.map((caseFilter: any, index: number) => {
                const conditionFilters = caseFilter?.conditionFilters?.map((condition: any) => {
                    // Ensure filter.id exists and is a string before parsing
                    let pFilterId = condition?.selectedFilters
                        ?.map((filter: any) => (filter && typeof filter.id === 'string' ? filter.id : NaN))
                    // .filter((id: number) => !isNaN(id));

                    // Ensure filterType exists and is a string before parsing
                    const isSkillDetailStr = condition?.filterSection?.value === 'Skill Detail Str';
                    const pType = isSkillDetailStr
                        ? '5'
                        : condition && typeof condition?.filterType === 'string' ? condition?.filterType : NaN;

                    // Only return if pType is a valid number and pFilterId is not empty
                    if (pFilterId && pFilterId?.length > 0) {
                        try {
                            if (isSkillDetailStr) {
                                try {
                                    pFilterId = condition?.selectedFilters
                                        ?.map((filter: any) => filter?.label)
                                        ?.filter((item: any) => typeof item === 'string' && item.length > 0) || [];
                                } catch (e) {
                                    console.log("error in parsing Skill Detail Str filter ids", e)
                                }
                            } else if (Array.isArray(pFilterId)) {
                                pFilterId = pFilterId.map((item: any) => {
                                    if (item) {
                                        if (typeof item === 'string' && item.split(',').length > 1) {
                                            return item.split(',').map((item: any) => parseInt(item, 10));
                                        }
                                        return parseInt(item, 10);
                                    }
                                    return null;
                                }).filter((item: any) => item !== null).flat(3);
                            }
                        } catch (e) {
                            console.log("error in transformCaseFiltersToApiParams", e)
                        }
                        return {
                            pType: pType,
                            pFilterId: pFilterId,
                        };
                    }
                    return null; // Return null for invalid conditions
                }).filter((cf: any) => cf !== null); // Filter out null (invalid) conditions

                let condition: any = {};
                if (conditionFilters?.length > 1) {
                    condition.operator = caseFilter?.condition || "AND";
                }
                return {
                    ...condition,
                    conditions: conditionFilters || [],
                    name: `case ${index + 1}`,
                };
            }).filter((c: any) => c?.conditions?.length > 0); // Ensure the case has valid conditions

            // The top-level operator seems to combine the different cases.
            // Based on the API example structure, it looks like the cases are OR'd together.
            // The caseFiltersData.caseCondition ("AND" in the example) applies *within* a case.
            if (apiConditions?.length === 0) {
                return "0";
            }
            let filter: any = {};
            // if (apiConditions?.length > 1) {
            //     filter.operator = caseFiltersData?.caseCondition || "AND";
            // }
            if (apiConditions?.length === 1 && apiConditions[0]?.conditions?.length === 1) {
                return {
                    filter: apiConditions[0]
                };
            }
            return {
                filter: {
                    ...filter,
                    operator: caseFiltersData?.caseCondition,
                    conditions: apiConditions,
                },
            };
        } catch (e) {
            console.log("error in transformCaseFiltersToApiParams", e)
            return "0";
        }
    }

    const getCurrentFilterValue = () => {
        try {
            if (filterSection?.value) {
                return filterSection.value;
            }
            return DynamicfilterTypes.find((item) => Number(item.id) === Number(filterType))?.value || 'Campaign';
        } catch (e) {
            console.log("error in getCurrentFilterValue", e)
        }
    };

    const getApiFilterType = () => {
        try {
            const currentFilterValue = getCurrentFilterValue();
            return currentFilterValue === 'Skill Detail Str' ? 5 : filterType;
        } catch (e) {
            console.log("error in getApiFilterType", e)
        }
    };

    const getDynamicWidgetFilterPayload = () => {
        try {
            if (!(dynamicWidgetFilter.length && !(responseLength === dynamicWidgetFilter.length))) {
                return '0';
            }

            if (getCurrentFilterValue() === 'Skill Detail Str') {
                return dynamicWidgetFilter
                    .map((item: any) => item?.label)
                    .filter((item: any) => typeof item === 'string' && item.length > 0)
                    .join(',');
            }

            return dynamicWidgetFilter.map((item: any) => item.id).join(',');
        } catch (e) {
            console.log("error in getDynamicWidgetFilterPayload", e)
        }
    };


    async function getTableCall(id: any, filters: any = '0') {
        try {
            if (value1 === '' && procedureId.current === '') return;
            tempColumns = [];
            let params: any = { FilterId: filters, Type: getApiFilterType(), apiId: id, ...inputValues };
            if (isCaseFilter) {
                params = { Filter: "0", apiId: id, ...inputValues }
                try {
                    if (caseFilters?.caseFilters?.length > 0 && Array.isArray(caseFilters?.caseFilters)) {
                        params.Filter = transformCaseFiltersToApiParams(caseFilters)
                        console.log("params.Filter", params.Filter)
                    }
                } catch (e) {
                    console.log("error in getTableCall", e)
                }
                if (typeof params?.Filter === 'object') {
                    params.Filter = JSON.stringify(params?.Filter)
                }
            }
            try {
                if (isClickHouseQuery) {
                    const selectedFilterValue = DynamicfilterTypes.find(item => Number(item.id) === Number(params.Type))?.value;
                    if (selectedFilterValue && typeof selectedFilterValue === "string") {
                        const clickHouseFilterKey = selectedFilterValue === 'Skill Detail Str' ? 'Detail' : selectedFilterValue
                        params[clickHouseFilterKey + 'Id'] = params.FilterId;
                    }
                }
            } catch (e) { }
            let data: any = await getDynamicWidgetAPI(params);
            // widget location 6 is used for clickhouse querries
            if (isClickHouseQuery && data && typeof data === "object" && !Array.isArray(data) && Object.keys(data).length > 0 && "data" in data && Array.isArray(data?.data)) {
                data = data?.data;
            }
            if (data?.length > 0) {
                let tempK: any = '';
                if (data && data?.length > 0) {
                    tempK = Object.keys(data[0]).join(',');
                }
                setValue2(['All', ...Object.keys(data[0])]);
                tempHeaders.current = tempK;
                setRowData(data);
                makingColumn();
            } else {
                tempHeaders.current = "";
                setValue2([]);
                setRowData([]);
                makingColumn();
            }
            setLastFetchedTime(getLastFetchedDetailFromBrowser());
        }
        catch (e) {
            console.error("error in getTableCall dynamic widget", e)
        }
    }

    const handleChangeProcedureId = (event: any) => {
        setInputValues({});
        setValue2([])
        setSelectedHeader(null)
        setNewHeaderMap([])
        setColumnData([])
        const selected = apiParams.find((widget: any) => widget.widgetID === event.target.value);
        setSelectedWidget(selected);

        setValue1(String(event.target.value));
        procedureId.current = String(event.target.value);
        props?.handleFilterChange?.(dynamicWidgetFilter, filterSection, props?.widgetId, procedureId.current, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    // const handleChangeUsersList = (event: any) => {
    //     const selectedUsers = event.target.value || [];

    //     setSelectedSubUser(selectedUsers);
    //     const selectedUserIds = selectedUsers.map((user: any) => user.id).join(',');
    //     selectedSubUserId.current = selectedUserIds;
    //     props?.handleFilterChange?.(dynamicWidgetFilter, filterSection, props?.widgetId, procedureId.current, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, selectedUserIds, dynamicWidget);
    // };


    const unwantedParams = ["FilterId", "UserId", "Type"];

    const handleInputChange = (param: string, event: any) => {
        setInputValues(prev => ({
            ...prev,
            [param]: event.target.value,
        }));
    };

    const getAllLeftParams = (id: any) => {
        if (id && id?.widgetParams) {
            const params = id.widgetParams.split(',').filter((param: any) => !unwantedParams.includes(param));
            setExtraParameters(params);

        }
    }

    async function getWidgetDetailsList() {
        setApiParams([]);
        try {
            getWidgetDetails("", "").then((resp: any) => {
                resp?.Data?.map((item: any) => {
                    if (item.widgetID === parseInt(props?.selectedFilters?.procedureId)) {
                        setSelectedWidget(item);
                    }
                })
                setApiParams(resp?.Data);
            }).catch(e => {
                setApiParams([])
            })
        }
        catch (e) {
            showErrorNotification(JSON.stringify(e));
        }
    }

    // useEffect(() => {
    //     if (props?.selectedFilters?.subUserId) {
    //         const selectedIdsArray = props?.selectedFilters?.subUserId?.split(',').map(Number);

    //         const preselectedUsers = usersList?.filter((user: any) => selectedIdsArray?.includes(user?.id));

    //         setSelectedSubUser(preselectedUsers);
    //     }
    // }, [props?.selectedFilters?.subUserId, usersList]);

    // async function getSubUserList() {
    //     setUsersList([]);
    //     try {
    //         getsubadmin().then((resp: any) => {
    //             setUsersList(resp?.Data);
    //         }).catch(e => {
    //             setUsersList([])
    //         })
    //     }
    //     catch (e) {
    //         showErrorNotification(JSON.stringify(e));
    //         setUsersList([])
    //     }
    // }

    useEffect(() => {
        getAllLeftParams(selectedWidget);
    }, [selectedWidget]);

    const handleFilterDelete = (id: Number) => {
        const newFilter = dynamicWidgetFilter.filter((item: any) => item.id !== id);
        setDynamicWidgetFilter(newFilter);
        props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId, value1, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    const clearFilter = () => {
        setDynamicWidgetFilter([]);
        props?.handleFilterChange?.([], filterSection, props?.widgetId, value1, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    const handleFilterExistingData = (filteredData: any) => {
        setDynamicWidgetFilter(filteredData);
        props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId, value1, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    const handleChangeRefreshTime = (data: any) => {
        setFinalRefreshTime(data);
        tempFinalRefresh.current = data;
        props?.handleFilterChange?.(dynamicWidgetFilter, filterSection, props?.widgetId, value1, value2, JSON.stringify(newHeaderMap), filterToShow, widgetTitleName, inputValues, data, '', dynamicWidget);
        resetInterval(tempFinalRefresh.current);
    };

    const resetInterval = (data: any) => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        const filterIds = getDynamicWidgetFilterPayload();

        if (parseInt(data) > 0) {
            intervalRef.current = setInterval(() => getTableCall(procedureId.current, filterIds), parseInt(data) * 1000);
        }
    };

    const handleChangeTitleName = (data: any) => {
        setWidgetTitleName(data);
    }

    const makingColumn = () => {
        if (newHeaderMap.length > 0) {
            let tempC: any = [];
            newHeaderMap.map((item: any, index: any) => {
                const columnDef: any = {
                    field: `${item.headerName}`,
                    headerName: `${item.alias ? item.alias : item.headerName}`,
                    name: `${item.alias ? item.alias : item.headerName}`,
                    key: `${item.headerName}`,
                    minWidth: 120
                };

                // Add custom cell renderer for time columns
                if (item.isTime) {
                    columnDef.cellRenderer = (params: any) => {
                        try {
                            const value = params.value;
                            if (value === null || value === undefined || value === '') return '';
                            if (value === 'TOTAL') return value; // Don't format TOTAL rows

                            const numericValue = parseInt(value, 10);
                            if (isNaN(numericValue)) return value;

                            return formatSecondsToTime(numericValue);
                        } catch (e) {
                            console.error("error in makingColumn", e)
                            return '';
                        }
                    };
                }

                tempC.push(columnDef);
            })
            setColumnData(tempC)
        }
    }

    const handleKeyDownTitle = (event: any) => {
        if (event.key === 'Enter') {
            setWidgetTitleName(widgetTitleName);
        }
    };

    const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection }: any) => {
        setFilterType(newFilterType);
        setFilterSection(newfilterSection);
        setDynamicWidgetFilter(selectedFilters);
        toggleDrawer(false);
        props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId, value1, value2, value3, filterToShow, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    const filterItems = dynamicWidgetFilter.map((item: any, index: number) => (
        <Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
    ));

    const toggleThresholdDrawer = (isOpen: boolean, data: any = null) => {
        setIsThresholdDrawerOpen(isOpen);
        if (data) {
            setThresholdItems(data);
        }
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    function getStyles(name: string, filterToShow: readonly string[], theme: Theme) {
        return {
            fontWeight:
                filterToShow.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    const handleChange = (event: SelectChangeEvent<typeof filterToShow>) => {
        const {
            target: { value },
        } = event;
        setFilterToShow(
            typeof value === 'string' ? value.split(',') : value,
        );
        props?.handleFilterChange?.(dynamicWidgetFilter, filterSection, props?.widgetId, value1, tempHeaders.current, JSON.stringify(newHeaderMap), value, widgetTitleName, inputValues, tempFinalRefresh.current, '', dynamicWidget);
    };

    React.useEffect(() => {
        const filterIds = getDynamicWidgetFilterPayload();
        getTableCall(procedureId.current, filterIds);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        resetInterval(tempFinalRefresh.current);
    }, [dynamicWidgetFilter, thresholdItems, isCaseFilter, caseFilters, isClickHouseQuery]);

    useEffect(() => {
        getWidgetDetailsList();
        // getSubUserList();
        return () => {
            clearInterval(intervalRef.current);
        };
    }, []);

    function getRowData(row: any) {
        try { // Doing Time formatting for isTime columns
            return row.map((rowItem: any) => {
                const formattedRow = { ...rowItem };
                newHeaderMap.forEach((headerItem: any) => {
                    if (headerItem.isTime && formattedRow[headerItem.headerName] !== undefined) {
                        const value = formattedRow[headerItem.headerName];
                        if (value !== null && value !== undefined && value !== '' && value !== 'TOTAL') {
                            const numericValue = parseInt(value, 10);
                            if (!isNaN(numericValue)) {
                                formattedRow[headerItem.headerName] = formatSecondsToTime(numericValue);
                            }
                        }
                    }
                });
                return formattedRow;
            });
        } catch (e) {
            console.error("error in getRowData", e)
            return row;
        }
    }

    const toggleRefresh = () => {
        const filterIds = getDynamicWidgetFilterPayload();
        setToggleState(true);
        getTableCall(procedureId.current, filterIds);
    };

    const defaultColDef = useMemo(() => {
        return {
            filter: 'agTextColumnFilter',
            // floatingFilter: true,
            cellClass: "dynamic-widget-cell-center",
            headerClass: 'dynamic-widget-header-center',
            flex: 1,
            // minWidth: 200,
            // wrapHeaderText: true,
            tooltipValueGetter: (params: any) => params?.value || "",

        };
    }, []);

    const getRowClass = useCallback((params: any) => {
        // Check if any field in this row has the value "TOTAL"
        try {
            const rowData = params.data;
            const isTotalRow = Object.values(rowData).some((value: any) => value === "TOTAL");

            if (isTotalRow) {
                return 'oz-dynamic-ag-grid-total-row';
            } else if (params.node.rowIndex % 2 !== 0) {
                return 'odd-row';
            } else {
                return '';
            }
        } catch (error) {
            console.error("Error in getRowClass Dynamic Widget", error);
            return '';
        }
    }, []);

    function handleChangeCaseFilterCheckbox(e: any) {
        setIsCaseFilter(e.target.checked);
        if (props && props?.handleSaveDataToFilter) {
            props?.handleSaveDataToFilter({
                widgetId: props?.widgetId,
                value: {
                    isCaseFilter: e.target.checked
                }
            })
        }
    }

    function toggleCaseFilterDrawer(isOpen: boolean) {
        setIsCaseFilterDrawerOpen(isOpen);
    }

    function handleApplyCaseFilters(filters: any) {
        console.log("handleApplyCaseFilters filters", filters)
        setCaseFilters(filters);
        toggleCaseFilterDrawer(false);
        if (props && props?.handleSaveDataToFilter) {
            props?.handleSaveDataToFilter({
                widgetId: props?.widgetId,
                value: {
                    caseFilters: filters
                }
            })
        }
    }

    return (
        <Grid ref={downloadContent} container xs={12} direction='row' height="100%">
            <Grid item xs={(showFilters && checkRoles("ROLE_ADMIN")) ? 7.5 : 12} flexGrow={1} height="100%">
                <Card className="customCard" sx={{ height: "100%" }}>
                    <div className="card-header">
                        <div className="card-title">
                            {widgetTitleName}
                            {parseInt(tempFinalRefresh.current) > 0 && <div className="card-title-badge">Live</div>}
                            {parseInt(tempFinalRefresh.current) <= 0 &&
                                <>
                                    <div className="refresh-btn card-icon" onClick={() => toggleRefresh()}>
                                        <RefreshOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
                                    </div>
                                </>
                            }
                            <span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
                        </div>
                        <div className="card-actions">
                            <WidgetDownload element={downloadContent} handleDownload={handleDownload} xlsx rowData={getRowData(rowData)} columns={columnData} name={widgetTitleName || 'Dynamic Widget'}></WidgetDownload>
                            {filterToShow?.length > 0 ? <div className="card-icon" onClick={() => {
                                if (isCaseFilter) {
                                    toggleCaseFilterDrawer(true);
                                } else {
                                    toggleDrawer(true)
                                }
                            }}>
                                <Badge badgeContent={dynamicWidgetFilter.length + caseFiltersLength} color="primary">
                                    <FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
                                </Badge>
                            </div> : null}
                        </div>
                    </div>
                    {isCaseFilter ? <FilterDrawerCaseWise
                        isOpen={isCaseFilterDrawerOpen}
                        toggleDrawer={toggleCaseFilterDrawer}
                        applyFilters={handleApplyCaseFilters}
                        existingCaseFilters={caseFilters}
                        allowedFilters={filterToShow}
                    /> : <FilterDrawer DynamicWidget isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} existingSelectedFilters={dynamicWidgetFilter} allowedFilters={filterToShow} setResponseLength={setresponseLength} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} />
                    }
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        {(dynamicWidgetFilter.length > 0 || caseFiltersLength > 0) && (
                            <Accordion
                                expanded={showFiltersAccordion}
                                onChange={() => setShowFiltersAccordion(!showFiltersAccordion)}
                                disableGutters
                                elevation={0}
                                sx={{
                                    m: 0,
                                    border: 'none',
                                    '&:before': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        minHeight: '30px',
                                        padding: '0 10px',
                                        '& .MuiAccordionSummary-content': {
                                            margin: '4px 0',
                                            justifyContent: 'space-between',
                                        }
                                    }}
                                >
                                    <Typography sx={{ fontSize: '13px', fontWeight: 'bold' }}>
                                        Selected Filters
                                    </Typography>
                                    {!isCaseFilter && (
                                        <Chip
                                            onClick={(e: any) => {
                                                e.stopPropagation();
                                                clearFilter();
                                            }}
                                            label="Clear Filters"
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            sx={{ fontSize: '11px', height: '20px', mr: '10px' }}
                                        />
                                    )}
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: '0 10px 10px 10px' }}>
                                    <div className="filter-container">
                                        <Stack direction="row" spacing={1}>
                                            {isCaseFilter ? caseFilterChipItems : dynamicWidgetFilter.length > 0 ? filterItems : null}
                                        </Stack>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </Box>
                    <div className='oz-dynamic-ag-grid' style={{ height: (dynamicWidgetFilter.length > 0 || caseFiltersLength > 0) ? showFiltersAccordion ? "calc(100% - 106px)" : "calc(100% - 74px)" : "calc(100% - 44px)" }}>
                        <AgGridReact
                            ref={downloadContent}
                            className="ag-theme-alpine"
                            defaultColDef={defaultColDef}
                            rowData={newHeaderMap.length > 0 ? rowData : []}
                            columnDefs={columnData}
                            rowHeight={38}
                            headerHeight={39}
                            getRowClass={getRowClass}
                        />
                    </div>
                    <ThresholdDrawer isOpen={isThresholdDrawerOpen} title={'Dynamic Widget'} toggleDrawer={toggleThresholdDrawer} thresholdItems={thresholdItems} />
                </Card>
            </Grid>
            {showFilters && checkRoles("ROLE_ADMIN") &&
                <Grid item xs={4.5} height={"100%"}>
                    <Box sx={box}>
                        <Grid direction={'column'} container gap={2} >
                            <Grid item >
                                <TextField
                                    id="title-name"
                                    label="Widget Name"
                                    variant="outlined"
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (value) {
                                            value = sanitizeInput(value);
                                        }
                                        handleChangeTitleName(value)
                                    }}
                                    value={widgetTitleName}
                                    onKeyDown={handleKeyDownTitle}
                                    fullWidth
                                    size='small'
                                    sx={{ marginBottom: '10px', marginTop: '5px' }}
                                />
                            </Grid  >

                            <Grid item >
                                <Autocomplete
                                    options={apiParams}
                                    getOptionLabel={(option) => option?.widgetName}
                                    onChange={(event: any, newValue: any) => {
                                        handleChangeProcedureId({
                                            target: { value: newValue ? newValue?.widgetID : '' },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Procedure Name"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option?.widgetID}>
                                            {option?.widgetName}
                                        </li>
                                    )}
                                    value={apiParams.find((widget: any) => widget?.widgetID === selectedWidget?.widgetID) || null}
                                    isOptionEqualToValue={(option: any, value: any) => option?.widgetID === value?.widgetID}
                                    filterSelectedOptions
                                    autoHighlight
                                    fullWidth
                                />
                                {/* <Autocomplete
                                    multiple
                                    limitTags={2}
                                    options={usersList}
                                    getOptionLabel={(option) => option?.username}
                                    onChange={(event: any, newValue: any, reason: any) => {
                                        let selectedUsers = [...newValue];
                                        if (reason === "removeOption") {
                                            try {
                                                const removedUsers = selectedSubUser.filter((prevUser: any) =>
                                                    !newValue.some((newUser: any) => newUser.id === prevUser.id)
                                                );
                                                removedUsers.forEach((removedUser: any) => {
                                                    if (prevSelectedSubUserIds.includes(removedUser.id)) {
                                                        selectedUsers.push(removedUser);
                                                    }
                                                });
                                            } catch (error) {
                                                console.log("error in onChange", error)
                                            }
                                        }
                                        handleChangeUsersList({
                                            target: { value: selectedUsers },
                                        });
                                    }}
                                    componentsProps={{ paper: { sx: { border: "1px solid #D6D6D7", marginTop: "6px", borderRadius: "8px" } } }}
                                    clearIcon={null}
                                    value={selectedSubUser}
                                    getOptionDisabled={(option: any) => prevSelectedSubUserIds.includes(option?.id)}
                                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                    disableClearable
                                    disableCloseOnSelect={true}
                                    autoHighlight
                                    fullWidth
                                    ChipProps={{ onDelete: () => { }, deleteIcon: <></> }}
                                    sx={{ marginTop: '10px', marginBottom: '5px' }}
                                    renderOption={(props: any, option: any, { selected, inputValue }: any) => <Box {...props} sx={{
                                        paddingLeft: "10px !important",
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        height: '24px !important',
                                        overflow: 'hidden',
                                    }}>
                                        <Typography textOverflow={"ellipsis"} overflow={"hidden"} whiteSpace={"nowrap"} width={"100%"} fontSize={"12px"} fontWeight={400} color={"#3D4C5E"} textTransform={"capitalize"}>
                                            {option?.username}
                                        </Typography>
                                    </Box>}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Sub-User"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                /> */}
                            </Grid  >
                            <Grid container gap={1} direction='row' >
                                <Grid item md={7}>
                                    <Autocomplete
                                        // multiple
                                        // disableCloseOnSelect
                                        // limitTags={2}
                                        id="headers-values"
                                        size="small"
                                        value={selectedHeader}
                                        options={value2}
                                        getOptionLabel={(option: string) => option}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Headers" placeholder="Select headers" />
                                        )}
                                        onChange={(event: any, newValue: string | null) => {
                                            setSelectedHeader(newValue);
                                        }}

                                    />
                                </Grid >
                                <Grid item md={2} >
                                    <Button disabled={!selectedHeader} variant="outlined" onClick={() => { addHeader(selectedHeader) }}>Add</Button>
                                </Grid >
                                <Grid item md={2.5} >
                                    <Button variant="outlined" onClick={() => { addHeader() }}>Manual Add</Button>
                                </Grid >
                            </Grid>
                            {newHeaderMap.length > 0 && <Grid container direction={'column'} sx={{ backgroundColor: 'rgba(237, 240, 242, 0.45)', borderRadius: '8px', padding: '10px' }} >

                                <Grid>
                                    <Typography fontWeight={500} color={"#545454"}>Map Headers</Typography>
                                </Grid>

                                {/* Header Row */}
                                <Grid container gap={.5} sx={{ marginBottom: '8px', marginTop: '8px' }}>
                                    <Grid item md={3.5}>
                                        <Typography variant="caption" fontWeight={600} color={"#666"}>Header Name</Typography>
                                    </Grid>
                                    <Grid item md={3.5}>
                                        <Typography variant="caption" fontWeight={600} color={"#666"}>Alias</Typography>
                                    </Grid>
                                    <Grid item md={2.5}>
                                        <Typography variant="caption" fontWeight={600} color={"#666"}>Time Format</Typography>
                                    </Grid>
                                    <Grid item md={1.5}>
                                        <Typography variant="caption" fontWeight={600} color={"#666"}>Action</Typography>
                                    </Grid>
                                </Grid>

                                <Stack gap={1}  >
                                    {newHeaderMap.map((item, index) => {
                                        return (
                                            <Grid container gap={.5} key={index + (item.headerName || item.alias || '')} alignItems={'center'}>
                                                <Grid item md={3.5}>
                                                    <TextField
                                                        variant="outlined"
                                                        onBlur={(e) => {
                                                            let value = e.target.value;
                                                            if (value) {
                                                                value = sanitizeInput(value);
                                                            }
                                                            updateHeader(index, value, item.alias, item.isTime)
                                                        }}
                                                        defaultValue={item.headerName}
                                                        size="small"
                                                        sx={{ marginRight: '10px' }}
                                                        placeholder="Header Name"
                                                    />
                                                </Grid>
                                                <Grid item md={3.5}>
                                                    <TextField
                                                        variant="outlined"
                                                        onBlur={(e) => {
                                                            let value = e.target.value;
                                                            if (value) {
                                                                value = sanitizeInput(value);
                                                            }
                                                            updateHeader(index, item.headerName, value, item.isTime)
                                                        }}
                                                        size="small"
                                                        defaultValue={item.alias}
                                                        sx={{ marginRight: '10px' }}
                                                        placeholder="Alias"
                                                    />
                                                </Grid>
                                                <Grid item md={2.5}>
                                                    <OZCheckbox
                                                        id={`isTime-${index}`}
                                                        label="IsTime"
                                                        checked={item.isTime || false}
                                                        onChange={(e: any) => updateHeader(index, item.headerName, item.alias, e.target.checked)}
                                                    />
                                                </Grid>
                                                <Grid item md={1.5}>
                                                    <IconButton onClick={() => { deleteHeader(index) }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        )
                                    })}
                                </Stack>
                            </Grid>
                            }
                            <OZCheckbox
                                id="isCaseFilter"
                                label="Case Filter"
                                checked={isCaseFilter}
                                onChange={handleChangeCaseFilterCheckbox}
                            />
                            <FormControl fullWidth size='small'>
                                <InputLabel id="refresh-time-label" sx={{ marginTop: '20px' }}>Refresh Time</InputLabel>
                                <Select
                                    id="refresh-time"
                                    label="Refresh Time"
                                    variant="outlined"
                                    sx={{ marginBottom: '5px', marginTop: '20px' }}
                                    onChange={(e) => handleChangeRefreshTime(e.target.value)}
                                    value={finalRefreshTime}
                                    fullWidth
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                            },
                                        },
                                    }}
                                >
                                    {refreshTimeDropDown.map((item: any) => (
                                        <MenuItem value={item.value} key={item.value}>{item.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth size='small'>
                                <InputLabel htmlFor='filter-type' id="filter-type-label">Filter Type</InputLabel>
                                <Select
                                    labelId="filter-type-label"
                                    id="filter-type"
                                    multiple
                                    label='Filter Type'
                                    value={filterToShow}
                                    onChange={handleChange}
                                    renderValue={(selected) => (
                                        <Box  >
                                            {selected.map((value: any) => (
                                                <Chip key={value} label={value} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {names.map((name) => (
                                        <MenuItem
                                            key={name}
                                            value={name}
                                            style={getStyles(name, filterToShow, theme)}
                                        >
                                            {name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {extraParameters.map((param: any, index: any) => (
                                <Grid container key={index} gap={2}>
                                    <Grid item md={5}>
                                        <Select
                                            value={param}
                                            input={<OutlinedInput />}
                                            disabled
                                            fullWidth
                                            size='small'
                                        >
                                            <MenuItem value={param}>{param}</MenuItem>
                                        </Select>
                                    </Grid>

                                    <Grid item >
                                        <TextField
                                            size='small'
                                            label={`Enter ${param}`}
                                            variant="outlined"
                                            value={inputValues[param] || ""}
                                            onChange={(e) => {
                                                console.log("sb dyn", e);
                                                try {
                                                    let value = e?.target?.value;
                                                    if (value) {
                                                        value = sanitizeInput(value);
                                                    }
                                                    handleInputChange(param, { target: { value } })
                                                } catch (error) {
                                                    console.log(error);
                                                    handleInputChange(param, e)
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Grid>
            }
        </Grid >
    );
}

export default NewDynamicWidget;
